import clienteAxios from "../config/axios";

export async function getAllActivos() {
    return clienteAxios.get(`/activo`);
}

export async function getActivosAllowed(activosAllowed = []){
    return clienteAxios.post(`/activosAllowed`,{activosAllowed});
}

export async function addActivo(activo, itemsList) {

    const activoToUpload = { 
            name:activo.name,
            img: activo.img,
            codActivo: activo.codActivo, 
            position: activo.position, 
            solicitaLecturaODT: activo.solicitaLecturaODT, 
            fecIng: activo.fecIng,
            tipPro: activo.tipPro,
            artCod:activo.artCod,
            descrp: activo.descrp,
            DEFAULTUNIMED: activo.DEFAULTUNIMED,
            ajusteLecturas: activo.ajusteLecturas,
            DEFAULTUNIMED2: activo.DEFAULTUNIMED2,
            ajusteLecturas2: activo.ajusteLecturas2,
            vidaUtil: activo.vidaUtil,
            tipoActivoID: activo.activoType.id,
            nameTypeActivo:activo.activoType.nameTypeActivo,
            fijo: activo.fijo,
            habilitadoProduccion: activo.habilitadoProduccion ?? false,
            fServ: activo.fServ,
            priority:activo.priority,
            criticidad:activo.priority,
            activoNivel1ID: activo.nivel1.id,
            codNivel1: activo.nivel1.codNivel1,
            
            ...(activo.nivel2?.id && {activoNivel2ID: activo.nivel2.id}),
            // activoNivel2ID: activo.nivel2.id, 
            codNivel2: activo.nivel2?.codNivel2 ?? '',
            
            ...(activo.nivel3?.id && {activoNivel3ID: activo.nivel3.id}),
            // activoNivel3ID: activo.nivel3.id,
            nameNivel3: activo.nivel3?.nameNivel3 ?? '',

            ...(activo.nivel4?.id && {activoNivel4ID: activo.nivel4.id}),
            // activoNivel4ID: activo.nivel4.id, 
            codNivel4: activo.nivel4?.codNivel4 ?? '',

            ...(activo.nivel5?.id && {activoNivel5ID: activo.nivel5.id}),
            // activoNivel5ID: activo.nivel5.id, 
            codNivel5: activo.nivel5?.codNivel5 ?? '',

            codQR:activo.codQR, 
            userName: activo.userName,
            activoUserID: activo.activoUserID,
            logsFServ: activo.logsFServ ?? [],
            logsUbicaciones: activo.logsUbicaciones ?? [],
            procedimientos: activo.procedimientos ?? [],
            lecturas: activo.lecturas ?? [],
            procsProgramados: activo.procsProgramados ?? [],
            documentos: activo.documentos ?? [],
            fichaTecnica: activo.fichaTecnica ?? [],
            activoUserID: activo.activoUserID,
            userName: activo.userName,
            // Campos de reserva
            reservable: activo.reservable ?? false,
            tipoReserva: activo.tipoReserva ?? null
    }
    let productsXactivo = itemsList.filter(product => product.artCod !== '')
    return clienteAxios.post(`/activo`,{activoToUpload, productsXactivo})
}

export async function updateActivo(activo, itemsList) {
    try {
        const id = activo._id;

        let updates = {
            id: activo._id,
            name: activo.name,
            img: activo.img,
            codActivo: activo.codActivo,
            position: activo.position, 
            solicitaLecturaODT: activo.solicitaLecturaODT, 
            DEFAULTUNIMED: activo.DEFAULTUNIMED,
            ajusteLecturas: activo.ajusteLecturas,
            DEFAULTUNIMED2: activo.DEFAULTUNIMED2,
            ajusteLecturas2: activo.ajusteLecturas2,
            vidaUtil: activo.vidaUtil,
            fecIng: activo.fecIng,
            tipPro: activo.tipPro,
            artCod: activo.artCod,
            descrp: activo.descrp,
            tipoActivoID: activo.activoType.id, 
            nameTypeActivo: activo.activoType.nameTypeActivo,
            fecMod: activo.fecMod,
            fecAlt: activo.fecAlt,
            fijo: activo.fijo,
            habilitadoProduccion: activo.habilitadoProduccion ?? false,
            fServ: activo.fServ,
            priority:activo.priority,
            criticidad:activo.priority,
            activoNivel1ID: activo.nivel1.id,
            codNivel1: activo.nivel1.codNivel1,

            // ...(activo.nivel2?.id && {activoNivel2ID: activo.nivel2.id}),
            activoNivel2ID: activo.nivel2?.id ? activo.nivel2.id : undefined,
            // activoNivel2ID: activo.nivel2.id, 
            codNivel2: activo.nivel2?.codNivel2 ?? null,

            // ...(activo.nivel3?.id && {activoNivel3ID: activo.nivel3.id}),
            activoNivel3ID: activo.nivel3?.id ? activo.nivel3.id : undefined,
            // activoNivel3ID: activo.nivel3.id,
            nameNivel3: activo.nivel3?.nameNivel3 ?? null,

             // ...(activo.nivel2?.id && {activoNivel2ID: activo.nivel2.id}),
             activoNivel4ID: activo.nivel4?.id ? activo.nivel4.id : undefined,
             // activoNivel4ID: activo.nivel4.id, 
             codNivel4: activo.nivel4?.codNivel4 ?? null,

              // ...(activo.nivel2?.id && {activoNivel2ID: activo.nivel2.id}),
            activoNivel5ID: activo.nivel5?.id ? activo.nivel5.id : undefined,
            // activoNivel5ID: activo.nivel5.id, 
            codNivel5: activo.nivel5?.codNivel5 ?? null,
            
            codQR:  activo.codQR,
            userWorking: activo.userWorking,
            userName: activo.userName,
            activoUserID: activo.activoUserID,
            logsFServ: activo.logsFServ,
            logsUbicaciones: activo.logsUbicaciones,
            procedimientos: activo.procedimientos,
            lecturas: activo.lecturas,
            procsProgramados: activo.procsProgramados,
            documentos: activo.documentos,
            fichaTecnica: activo.fichaTecnica,
            // Campos de reserva
            reservable: activo.reservable ?? false,
            tipoReserva: activo.tipoReserva ?? null
        };
        let productsXactivo = itemsList.filter(product => product.artCod !== '')
        return clienteAxios.put(`/activo/${id}`,{updates, productsXactivo});
    } catch (error) {
        console.log("error en updateActivo dentro de activo.js");
        console.log(error);
            
    }
}
export async function modificarUserworkingActivo(activoId,updates) {
    try {
        let res = await clienteAxios.put(`/activo/${activoId}`,{updates,productsXactivo:[]});
        return res;
    } catch (error) {
        console.log("error en updateActivo dentro de activo.js");
        console.log(error);
    }
}

//funcion para eliminar
export async function deleteActivo(id, updates) {
    return clienteAxios.delete(`/activo/${id}`,updates);
}

//funcion para alternar deBaja (deshabilitar / habilitar)
export async function toggleDeBajaActivo(id) {
    return clienteAxios.put(`/activo/toggleDeBaja/${id}`);
}


//funcion trae el activo con los componentes
export async function getByCodActivo(codActivo) {
    return clienteAxios.get(`/activo/${codActivo}`);
}

//Bloque de Funciones asociadas a S3
export async function addFiles(formData) {
    return clienteAxios.post("/activo/file", formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
}
  
export async function deleteFile(fileName) {
    return clienteAxios.delete(`/activo/file/${fileName}`);
}

export async function deleteFilesByCampoAndActivo(codActivo, campo){
    return clienteAxios.delete(`/activo/files/${codActivo}/${campo}`);
}

export async function getFiles(codActivo, campo) {
    return clienteAxios.get(`/activo/file/${codActivo}/${campo}`);
}
export async function getDocFiles(codActivo) {
    return clienteAxios.get(`/activo/docFiles/${codActivo}`);
}
export async function getFServFiles(codActivo) {
    return clienteAxios.get(`/activo/fServFiles/${codActivo}`);
}
//Fin Bloque Funciones Asociadas a S3

export async function calcMantenimientos(){
    return clienteAxios.get('/activo/calcMantenimientos');
}

export async function calcMantenimientoByActivo(activo){
    return clienteAxios.post('/activo/calcMantenimientos',{activo:activo});
}

export async function getProcsProgramados(userId, filtros){
    return clienteAxios.get(`/procProgramado/${userId}${filtros}`);
}
export async function getDocs(){
    return clienteAxios.get('/activo/getDocs');
}
export async function getLastLectByUnidadAndActivo(activoID,uniMed){
    return clienteAxios.get(`/activo/getLastLect?activoID=${activoID}&uniMed=${uniMed}`);
}
export async function requestUpdateUserWorking(activoID,userWorking){
    return clienteAxios.put(`/activo/updateUserWorking`,{activoID:activoID, userWorking: userWorking});
}
export async function addNewLectura(newLect){
    return clienteAxios.post('/lecturasXactivo',{newLect:newLect})
}

export async function addProcProgramado(procProgramado){
    return clienteAxios.post('/activo/addProcProgramado',{procProgramado:procProgramado})
}
export async function addProcDirecto(procDirecto,activo){
    return clienteAxios.post('/activo/addProcDirecto',{procDirecto:procDirecto, activo:activo})
}
export async function updateProcProgramado(newProcProgramado){
    return clienteAxios.put('/activo/updateProcProgramado',{newProcProgramado});
}
export async function deleteProcProgramado(id){
    return clienteAxios.delete(`/procProgramado/delete/${id}`);
}
export async function checkProcProgramado(id){
    return clienteAxios.get(`/procProgramado/check/${id}`);
}
export async function updateFServ(activoID,fServActual,logToUpload){
    return clienteAxios.post('/activo/updateFServ',{activoID:activoID,fServActual:fServActual,logToUpload:logToUpload});
}
export async function checkIfActHasODTForBreaking(activoID){
    return clienteAxios.get(`/activo/hasODTForBreaking/${activoID}`);
}
export async function updateFecVencimientoDoc(activoID,documentoID,newFecha){
    return clienteAxios.put('/activo/updateFecVencimientoDoc',{activoID:activoID,documentoID:documentoID,newFecha:newFecha});
}
export async function getLecturasByActivoId(activoId,uniMed){
    return clienteAxios.get(`/activo/getLects?activoId=${activoId}&uniMed=${uniMed}`);
}
export async function updateUbicacionActivo(activoID,codActivo,ubicacionUpdates,userID,userName){
    return clienteAxios.put(`/activo/updateUbicacion`,{activoID,codActivo,ubicacionUpdates,userID,userName});
}
export async function getInfoActDashboard(filtrosEstado){
    return clienteAxios.post(`/activo/getInfoDashboard`, {filtrosEstado});
}
export async function getInfoActReporte(filtrosEstado){
    return clienteAxios.post(`/activo/getInfoReport`, {filtrosEstado});
}
export async function getControlServicios(activos = []){
    return clienteAxios.post(`/activo/getControlServicios`, { activos });
}
export async function getConsumoHorasMensual(dateFrom, dateTo){
    return clienteAxios.get(`/activo/getConsumoHorasMensual?dateFrom=${dateFrom}&dateTo=${dateTo}`);
}
export async function setCambioHorometro(activoID, periodo, cambioHorometro){
    return clienteAxios.put(`/activo/cambioHorometro`, { activoID, periodo, cambioHorometro });
}
export async function updatePositioning(updates){
    return clienteAxios.post(`/activo/updatePositioning`,{updates});
}
export async function getActivosAsOptions(filter) {
    return clienteAxios.get(`/activosListed${filter ? `?filter=${filter}` : ''}`);
}